import { ISearchElementStyle } from './searchPageConfig';
import { ILayout } from './layout';

// Custom header links config, persisted as a JSON string on IStorefrontSettings.headerLinksConfig.
// Rendered centered in the storefront header bar (see ac-storefront-web NavBar). Mirror of the storefront
// front-end's Components/Helpers/headerLinksConfig.ts — keep the two in sync.

export interface IHeaderLink {
    id?: string;
    label?: string;
    url?: string;
    iconUrl?: string;            // uploaded image blob URL, shown left of the label
    newTab?: boolean;            // open in a new tab
    style?: ISearchElementStyle; // per-link font/type/color/background/border/padding
    children?: IHeaderLink[];    // nested dropdown menu items (AC-934/Stage 1); absent = plain link
    panel?: ILayout;             // rich hover flyout / mega-menu (Stage 5): a grid layout in a popover
    panelFullWidth?: boolean;    // render the panel as a full-width bar below the header (AC-968)
    trigger?: 'hover' | 'click'; // how the dropdown/panel opens (default: hover desktop, tap touch)
}

export interface IHeaderLinksConfig {
    container?: ISearchElementStyle; // styling for the centered links container
    cellStyle?: ISearchElementStyle; // default styling applied to every link cell/chip
    // How the links sit in the space between the logo and the header actions. Defaults to 'center'.
    align?: 'left' | 'center' | 'right';
    links?: IHeaderLink[];
    // Links rendered in the header actions area (right, left of cart/account) — e.g. Support + a
    // Contact CTA (AC-970). Same IHeaderLink shape as `links`.
    actionLinks?: IHeaderLink[];
    // Surface of the dropdown a link with `children` opens. Absent ⇒ inherits headerConfig.menu (the
    // built-in category menu's surface), else a luminance-aware default from the header bar — so it is
    // never a white slab under a dark header. Set only to make the nav dropdown differ from that menu.
    dropdown?: ISearchElementStyle;
    [prop: string]: unknown;
}

// Map the header-links alignment to a flex justify-content value (default centered).
export const headerLinksJustify = (align?: 'left' | 'center' | 'right'): 'flex-start' | 'center' | 'flex-end' =>
    align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';

export function parseHeaderLinksConfig(raw?: string): IHeaderLinksConfig {
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? (parsed as IHeaderLinksConfig) : {};
    } catch {
        return {};
    }
}

export function serializeHeaderLinksConfig(config: IHeaderLinksConfig): string {
    return JSON.stringify(config);
}
